import { render } from "./SubstrateBuckets.vue?vue&type=template&id=382c3a3a&scoped=true"
import script from "./SubstrateBuckets.vue?vue&type=script&lang=js"
export * from "./SubstrateBuckets.vue?vue&type=script&lang=js"

import "./SubstrateBuckets.vue?vue&type=style&index=0&id=382c3a3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-382c3a3a"]])

export default __exports__